<template>
  <vx-card
    class="p-0"
    :title="$t('update_school_information')"
  >
    <form data-vv-scope="School">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full" >
          <p class="mt-4"> {{ $t('head_of_school') }} <b style="color: #ff6141;">*</b> </p>
          <v-select :options="responsables" :reduce="(rep) => rep.id" @search="getResponsable" :clearable="true" label="full_name" v-model="input.responsable" class="w-full" name="responsable" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.responsable') }} </span>

          <p class="mt-4"> Caissier <b style="color: #ff6141;">*</b> </p>
          <v-select :options="responsables" :reduce="(rep) => rep.id" @search="getResponsable" :clearable="true" label="full_name" v-model="input.caissier" class="w-full" name="responsable" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.caissier') }} </span>

          <p class="mt-4"> {{ $t('school_name') }} <b style="color: #ff6141;">*</b> </p>
          <vs-input v-model="input.school_name" class="w-full" name="school_name" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.school_name') }}
          </span>

          <p class="mt-4"> {{ $t('school_bp') }} <b style="color: #ff6141;">*</b> </p>
          <vs-input v-model="input.school_bp" class="w-full" name="school_bp" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.school_bp') }}
          </span>

          <p class="mt-4"> {{ $t('school_address') }} <b style="color: #ff6141;">*</b> </p>
          <vs-input v-model="input.school_address" class="w-full" name="school_address" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.school_address') }} </span>

          <p class="mt-4"> {{ $t('school_email') }} <b style="color: #ff6141;">*</b> </p>
          <vs-input v-model="input.school_email" class="w-full" name="school_email" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.school_email') }} </span>

          <p class="mt-4"> {{ $t('school_tel1') }} <b style="color: #ff6141;">*</b> </p>
          <vs-input v-model="input.school_tel1" class="w-full" name="school_tel1" v-validate="'required'" />
          <span class="text-danger"> {{ errors.first('School.school_tel1') }} </span>

          <p class="mt-4">{{ $t('school_tel2') }}</p>
          <vs-input v-model="input.school_tel2" class="w-full" />
        </div>

        <div class="vx-col md:w-1/2 w-full" >

          <p class="mt-4">{{ $t('school_tel3') }}</p>
          <vs-input v-model="input.school_tel3" class="w-full" />

          <p class="mt-4">nom de domaine du serveur</p>
          <vs-input v-model="input.nomDeDomaineDuServeur" class="w-full" />

          <!-- Logo Desired -->

          <div class="mt-8">
            <template v-if="uploadPhoto || (input && input.school_logo)">
              <!-- Image Container -->
              <div class="img-container w-20 h-20 mx-auto flex items-center justify-center" style="width: 400px;">
                <img v-if="uploadPhoto" :src="uploadPhoto" alt="img" class="responsive" />
                <img v-if="input.school_logo && !uploadPhoto" :src="seePicture(input.school_logo)" alt="img" class="responsive" />
              </div>

              <!-- Image upload Buttons -->
              <div class="modify-img flex justify-between mt-5">
                
                <vs-button
                  class="mr-4"
                  type="flat"
                  @click="$refs.updateImgInput.click()"
                >
                  {{ $t('Update_image') }}
                </vs-button>
                <vs-button type="flat" color="#999" @click="uploadPhoto = null">
                  {{ $t('Remove_image') }}
                </vs-button>
              </div>
            </template>
            <div class="upload-img mt-5">
              <input
                type="file"
                class="hidden"
                ref="updateImgInput"
                @change="updateCurrImg"
                accept="image/*"
              />
              <vs-button
                v-if="!uploadPhoto && input && !input.school_logo"
                @click="$refs.updateImgInput.click()"
              >
                {{ $t('Upload_logo') }}
              </vs-button>
            </div>
          </div>

        </div>
      </div>

      <vs-button class="mt-8" @click="School_validate" >{{ $t("Submit") }}</vs-button>
    </form>
  </vx-card>
</template>

<script>
// head_of_school
let base_self = ''

// For custom error message
import { Validator } from 'vee-validate'

// Inscription
const input_tempon = {
  id: null,
  responsable: '',
  caissier: '',
  school_name: '',
  school_bp: '',
  school_address: '',
  school_email: '',
  school_tel1: '',
  school_tel2: '',
  school_tel3: '',
  nomDeDomaineDuServeur: '',
  school_logo: ''

  /* my_first_setting: '',
  pourcentage_part_patronale: '',
  cloture_caisse: '',
  devise_monaie: '' */
}

export default {
  watch: {
    /* input: {
      handler () {
        base_self.input_watch(false)
      },
      deep: true
    } */
  },
  data () {
    return {
      uploadPhoto: '',
      dataImg1: [],
      dataImg_information: [],
      dataImg: null,
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      responsables: []
    }
  },
  methods: {
    seePicture (link) {
      console.log('link: ', link)
      if (!link) return ''

      link = link.substring(1)
      console.log('link: ', link)
      console.log('link: ', `${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}${link}`)
      return `${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}${link}`
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const length = input.srcElement.files.length
        for (let iuoy = 0; iuoy < length; iuoy++) {
          const reader = new FileReader()
          reader.onload = e => {
            // unshift
            base_self.uploadPhoto = e.target.result
            base_self.dataImg1.unshift(e.target.result)
            base_self.dataImg_information.unshift(base_self.$refs.updateImgInput.files[iuoy])
          }
          reader.readAsDataURL(input.target.files[iuoy])
        }
      }
    },
    getResponsableSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {},
        orderby: ['full_name']
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Employe`, data)
        .then((response) => {
          base_self.responsables = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getResponsable (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Employe`, data)
        .then((response) => {
          base_self.responsables = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    School_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('School').then((result) => {
          if (result) {
            base_self.submit()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    getParametre () {
      const data = {
        is_get: true,
        filter: { unique: 0 }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Parametre`, data)
        .then((response) => {
          base_self.input = response.data.data[0]
          base_self.input.responsable = base_self.input.responsable.id

          if (base_self.input.caissier.id) {
            base_self.input.caissier = base_self.input.caissier.id
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    async submit () {
      base_self.$vs.loading()
      
      const form = new FormData()
      form.append('id', base_self.input.id)
      form.append('responsable', base_self.input.responsable)
      form.append('caissier', base_self.input.caissier)
      form.append('school_name', base_self.input.school_name)
      form.append('school_bp', base_self.input.school_bp)
      form.append('school_address', base_self.input.school_address)
      form.append('school_email', base_self.input.school_email)
      form.append('school_tel1', base_self.input.school_tel1)
      form.append('school_tel2', base_self.input.school_tel2)
      form.append('school_tel3', base_self.input.school_tel3)
      form.append('nomDeDomaineDuServeur', base_self.input.nomDeDomaineDuServeur)

      if (base_self.dataImg_information.length) {
        form.append('school_logo', base_self.dataImg_information[0], base_self.dataImg_information[0].name)
      }
      
      base_self.$http
        .put(`${base_self.$store.state.route_for_esm}Parametre`, form)
        .then((response) => {
          window.getESM.success(base_self.$t('School_information_has_been_changed_successfully'), response)
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
      

      /* if (!input.id) {
        base_self.$http
          .post(`${base_self.$store.state.route_for_esm}Inscription`, input)
          .then((response) => {
            window.getESM.success(
              base_self.$t('The_student_is_added_successfully'),
              response,
            )
            base_self.$vs.loading.close()

            // console.log(' response ', response)
            base_self.$router
              .push('/Student_management/Student/main/0')
              .catch(() => {})
          })
          .catch((error) => {
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })
      } else if (input.id) {
        base_self.$http
          .put(`${base_self.$store.state.route_for_esm}Inscription`, input)
          .then((response) => {
            window.getESM.success(
              base_self.$t('The_student_is_changed_successfully'),
              response,
            )
            base_self.$vs.loading.close()
            base_self.$router
              .push('/Student_management/Student/main/0')
              .catch(() => {})
          })
          .catch((error) => {
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })
      } */
    }
  },
  components: {
  },
  created () {
    base_self = this

    base_self.getParametre()
    ///////////////////////////
    const dict = {
      custom: {
        responsable: {
          required: base_self.$t('The_head_of_school_is_required')
        },
        school_name: {
          required: base_self.$t('The_school_name_is_required')
        },
        school_bp: {
          required: base_self.$t('The_school_bp_is_required')
        },
        school_address: {
          required: base_self.$t('The_school_address_is_required')
        },
        school_email: {
          required: base_self.$t('The_school_email_is_required')
        },
        school_tel1: {
          required: base_self.$t('The_Phone_number_1_is_required')
        }
      }
    }
    // register custom messages
    Validator.localize('en', dict)
    //////////////////////////

    base_self.getResponsableSimple()
  }
}
</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
